import useSEO from "../hooks/useSEO";
import Hero from "../components/Hero";
import BrandMarquee from "../components/BrandMarquee";
import ServicesSection from "../components/ServicesSection";
import SefKamHomeSection from "../components/SefKamHomeSection";
import AIAutomationSection from "../components/AIAutomationSection";
import SoftwareEngineeringSection from "../components/SoftwareEngineeringSection";
import WhySefkam from "../components/WhySefkam";
import HowWeWork from "../components/HowWeWork";
import UseCases from "../components/UseCases";
import CTASection from "../components/CTASection";

export default function Home() {
  useSEO({
    title: "SefKam Digital Solutions | AI, Software & Smart Home Solutions",
    description: "SefKam Digital Solutions builds AI-powered software, automation, digital transformation solutions, and intelligent smart-home experiences.",
    path: "/",
  });
  return (
    <>
      <Hero />
      <BrandMarquee />
      <ServicesSection />
      <SefKamHomeSection />
      <AIAutomationSection />
      <SoftwareEngineeringSection />
      <WhySefkam />
      <HowWeWork />
      <UseCases />
      <CTASection />
    </>
  );
}
